import { Link } from "react-router-dom"
import { Phone, Mail } from "lucide-react"

export default function Header() {
  return (
    <header className="bg-white shadow-[0_2px_4px_rgba(0,0,0,0.08)] sticky top-0 z-50 h-[72px] flex items-center font-sans">
      <div className="container mx-auto flex items-center justify-between px-4">
        <div className="flex items-center gap-x-8">
          <Link to="/" aria-label="Carz Bazzar Home">
            <img
              src="/logo.jpeg"
              alt="Carz Bazzar"
              width={120}
              height={60}
              className="h-auto"
            />
          </Link>
        </div>
        
        {/* Right side buttons */}
        <div className="flex items-center gap-4">
          <a
            href="tel:+919773460662"
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-[#ff3131] text-white text-sm font-medium hover:bg-[#e62a2a] transition-colors"
          >
            <Phone size={16} />
            <span className="hidden sm:inline">Call</span>
          </a>
          <a
            href="mailto:carsbazzarmain@gmail.com"
            className="flex items-center gap-2 px-4 py-2 rounded-lg border border-gray-300 text-gray-700 text-sm font-medium hover:bg-gray-50 transition-colors"
          >
            <Mail size={16} />
            <span className="hidden sm:inline">Email</span>
          </a>
        </div>
      </div>
    </header>
  )
}